import { FeaturesCompatibilityAction } from './actions'
import fetchReducerFor, { fetchInitialState, FetchState } from '../redux/fetch/reducerFor'
import { FEATURES_COMPATIBILITY_PREFIX, FEATURES_COMPATIBILITY_RESOURCE_NAME, FeaturesCompatibility } from './model'

export type FeaturesCompatibilityFetcherState = FetchState<FeaturesCompatibility>

const featuresCompatibilityFetchReducer = (origin?: string) => {
  const featuresCompatibilityFetchReducerForOrigin =
    fetchReducerFor<FeaturesCompatibility>(FEATURES_COMPATIBILITY_RESOURCE_NAME, FEATURES_COMPATIBILITY_PREFIX, origin)
  return function reducer(state: FeaturesCompatibilityFetcherState = fetchInitialState,
                          action: FeaturesCompatibilityAction): FeaturesCompatibilityFetcherState {
    return {
      ...state,
      ...featuresCompatibilityFetchReducerForOrigin(state, action)
    }
  }
}

export default featuresCompatibilityFetchReducer
